import { c as _c } from "react/compiler-runtime";
import type { FAQPage, Question, WithContext } from 'schema-dts';
import { JsonLd } from './JsonLd';
export interface QuestionAnswer {
  question: string;
  answer: string;
}
export function FaqSeo(t0) {
  const $ = _c(7);
  const {
    id,
    qaArray
  } = t0;
  let t1;
  if ($[0] !== qaArray) {
    t1 = qaArray.filter(_temp).map(_temp2);
    $[0] = qaArray;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const mainEntity = t1;
  let t2;
  if ($[2] !== mainEntity) {
    t2 = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity
    };
    $[2] = mainEntity;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const faqSchema = t2;
  if (mainEntity.length === 0) {
    return null;
  }
  let t3;
  if ($[4] !== faqSchema || $[5] !== id) {
    t3 = <section><JsonLd id={id} data-testid={id} json={faqSchema} /></section>;
    $[4] = faqSchema;
    $[5] = id;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp2(t0) {
  const {
    question: question_0,
    answer: answer_0
  } = t0;
  return {
    "@type": "Question",
    name: question_0,
    acceptedAnswer: {
      "@type": "Answer",
      text: answer_0
    }
  };
}
function _temp(t0) {
  const {
    question,
    answer
  } = t0;
  return question && answer;
}